import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentGuard implements CanActivate {

  constructor(private router: Router,) { }

  emvs: string[] = ['admin', 'formulario/:id', 'que-son-emvs', 'clave/:id', 'firma-clave', 'instancia-general', 'anexo3_participacion_concurso', 'RPSV'];

  canActivate(
    route: ActivatedRouteSnapshot,
  ) {
    if (environment.environment == 'emvs') {
      if (this.emvs.includes(route.routeConfig.path)) {
        return true;
      } else {
        this.router.navigate(['login']);
        return false;
      }
    }
    return true;
  }
}